export const copyUrl = (button: HTMLElement): void => {
    button.addEventListener('click', () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
            const successElement = button.querySelector('.j-copy-url-success');

            if (successElement) {
                successElement.classList.add('active');

                setTimeout(() => {
                    successElement.classList.remove('active');
                }, 2000);
            }
        })
            .catch((error: Error) => {
                console.error('Ошибка при копировании URL: ', error);
            });
    });
};
